__turbopack_context__.v({
  "blinker": "Logo-module__l_qe3G__blinker",
  "cls1": "Logo-module__l_qe3G__cls1",
  "cls2": "Logo-module__l_qe3G__cls2",
  "cls3": "Logo-module__l_qe3G__cls3",
  "light": "Logo-module__l_qe3G__light",
  "logo": "Logo-module__l_qe3G__logo",
  "max": "Logo-module__l_qe3G__max",
});
